import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../../_services/langhfre.service';
import { NavigationService } from 'src/app/_services/navigation.service';

@Component({
  selector: 'app-inclusive-language-report',
  templateUrl: './inclusive-language-report.component.html',
  styleUrls: ['./inclusive-language-report.component.scss']
})
export class InclusiveLanguageReportComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    public navigationService: NavigationService
  ) { }

  ngOnInit() {
    this.titleService.setTitle('中性語言檢查 | 讓你的溝通無偏見');
    this.metaTagService.updateTag({ name: 'description', content: "讓你的寫作更具包容性，提升讀者互動與參與感。運用專業建議，推動多元、平等、包容與歸屬感（DEIB）的目標，透過有力的寫作策略帶來影響力。" });
    this.metaTagService.updateTag({ property: 'og:title', content: '中性語言檢查 | 讓你的溝通無偏見' });
    this.metaTagService.updateTag({ property: 'og:description', content: '讓你的寫作更具包容性，提升讀者互動與參與感。運用專業建議，推動多元、平等、包容與歸屬感（DEIB）的目標，透過有力的寫作策略帶來影響力。' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/features/inclusive-language-check' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/bias-banner.svg' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: ' Inclusive Language Check | Make Your Communication Bias Free' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "讓你的寫作更具包容性，提升讀者互動與參與感。運用專業建議，推動多元、平等、包容與歸屬感（DEIB）的目標，透過有力的寫作策略帶來影響力。" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/bias-banner.svg' });
    this.metaTagService.updateTag({ name: 'keywords', content: 'inclusive language checker, Microsoft Word Inclusivity Checker, best inclusive language tool, Inclusive Language Checker, Inclusive language checker online, Inclusive language checker free, microsoft word inclusive language checker, bias language checker, gender-inclusive language examples' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/features/inclusive-language-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/features/inclusive-language-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/features/inclusive-language-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/features/inclusive-language-check' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/features/inclusive-language-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/features/inclusive-language-check' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/features/inclusive-language-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/features/inclusive-language-check' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/features/inclusive-language-check' });
    
    //ire('identify', { 'customerId': '', customerEmail: '', customProfileId: '' });
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }

  showTab = 1;
  inclusiveLanguage(index: number) {
    this.showTab = index;
  }

  stopAllVideos() {
    const iframes = Array.from(document.querySelectorAll('iframe.youtubeVideoForTryDemo'));
    iframes.forEach((iframe) => {
        const htmlIframe = iframe as HTMLIFrameElement;
        htmlIframe.src = htmlIframe.src;
    });
  }

}
